import gql from 'graphql-tag';

export const GetUserStateQuery = gql`
	query GetUserState {
		isSiteAdmin
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;
